import { useState } from "react";
import WalletModal from "components/modals/WalletModal";
import { Btn, Card, SumCard, useIsMobile } from "components/ui/index";
import { MONTHS_FULL } from "constants/index";
import { T } from "theme/index";
import { fmtIDR, fmtShort } from "utils/format";
import { getAllWalletsMonth, getMonthActuals } from "engine/wallets";

export default function Dompet({ wallets, transactions, month, year, onAdd, onEdit, onDelete }) {
  const isMobile = useIsMobile();
  const [modal, setModal] = useState(null);

  const rows = getAllWalletsMonth(wallets, transactions, month, year);

  // Summary cards — hanya income vs expense/investasi, TIDAK termasuk transfer
  // biar tidak hitung uang yang sama berkali-kali saat transfer antar rekening
  const { actualIncome, actualExpense, actualSisa } = getMonthActuals(transactions, month, year);

  return (
    <div>
      {modal && <WalletModal wallet={modal==="add"?null:modal} onSave={modal==="add"?onAdd:onEdit} onClose={() => setModal(null)} />}

      {/* Summary bulan ini */}
      <div style={{ display:"grid", gridTemplateColumns:isMobile?"repeat(2,1fr)":"repeat(3,1fr)", gap:10, marginBottom:16 }}>
        <SumCard label="Pemasukan"     value={actualIncome}  color={T.green} prefix="+" />
        <SumCard label="Pengeluaran"   value={actualExpense} color={T.red} />
        <SumCard label="Sisa" value={actualSisa}   color={actualSisa>=0?T.gold:T.red} />
      </div>

      {/* Action bar */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
        <div style={{ color:T.text, fontWeight:700, fontSize:14 }}>Rekening — {MONTHS_FULL[month]} {year}</div>
        <Btn onClick={() => setModal("add")} style={{ fontSize:12, padding:"8px 12px" }}>＋ Tambah Rekening</Btn>
      </div>

      {wallets.length === 0 && (
        <Card style={{ padding:48, textAlign:"center", marginBottom:16 }}>
          <div style={{ fontSize:40, marginBottom:10 }}>🏦</div>
          <div style={{ color:T.text, fontWeight:700, fontSize:14, marginBottom:6 }}>Belum ada rekening</div>
          <div style={{ color:T.muted, fontSize:12, marginBottom:20 }}>Tambahkan rekening bank, e-wallet,<br/>atau kas tunaimu di sini.</div>
          <Btn onClick={() => setModal("add")} style={{ margin:"0 auto" }}>＋ Tambah Rekening</Btn>
        </Card>
      )}

      {/* Wallet cards — model Budget / Usages / Balance per bulan */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:12 }}>
        {rows.map(w => (
          <Card key={w.id} style={{ padding:18, border:`1px solid ${w.color}33`, background:`linear-gradient(135deg,${w.color}10 0%,${T.card} 100%)` }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:14 }}>
              <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                <div style={{ width:40, height:40, borderRadius:10, background:w.color+"30", display:"flex", alignItems:"center", justifyContent:"center", fontSize:22 }}>{w.icon}</div>
                <div>
                  <div style={{ color:T.text, fontWeight:700, fontSize:14 }}>{w.name}</div>
                  {w.bank && <div style={{ color:T.muted, fontSize:11, marginTop:1 }}>{w.bank}</div>}
                </div>
              </div>
              <div style={{ display:"flex", gap:4 }}>
                <button onClick={() => setModal(w)} aria-label={`Edit rekening ${w.name}`} style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:6, color:T.muted, cursor:"pointer", padding:"4px 7px", fontSize:12, WebkitTapHighlightColor:"transparent" }}>✏️</button>
                <button onClick={() => { if(window.confirm("Hapus rekening ini?")) onDelete(w.id); }} aria-label={`Hapus rekening ${w.name}`} style={{ background:T.red+"15", border:`1px solid ${T.red}28`, borderRadius:6, color:T.red, cursor:"pointer", padding:"4px 7px", fontSize:12, WebkitTapHighlightColor:"transparent" }}>🗑️</button>
              </div>
            </div>

            {/* Balance (sisa bulan ini) */}
            <div style={{ marginBottom:14 }}>
              <div style={{ color:T.muted, fontSize:10, fontWeight:700, letterSpacing:"0.07em", textTransform:"uppercase", marginBottom:4 }}>Saldo Saat Ini</div>
              <div style={{ color:w.balance>=0?w.color:T.red, fontSize:24, fontWeight:800, fontFamily:"monospace", fontVariantNumeric:"tabular-nums" }}>{fmtIDR(w.balance)}</div>
            </div>

            {/* Budget / Usages */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
              <div style={{ background:T.surface, borderRadius:8, padding:"9px 11px" }}>
                <div style={{ color:T.muted, fontSize:10, marginBottom:3 }}>Budget (Masuk)</div>
                <div style={{ color:T.green, fontFamily:"monospace", fontVariantNumeric:"tabular-nums", fontSize:13, fontWeight:700 }}>{fmtShort(w.budget)}</div>
              </div>
              <div style={{ background:T.surface, borderRadius:8, padding:"9px 11px" }}>
                <div style={{ color:T.muted, fontSize:10, marginBottom:3 }}>Usages (Keluar)</div>
                <div style={{ color:T.red, fontFamily:"monospace", fontVariantNumeric:"tabular-nums", fontSize:13, fontWeight:700 }}>{fmtShort(w.usages)}</div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

// ── Dashboard ─────────────────────────────────────────────────────────────────
